import { useState } from "react";
import { Link, useLocation } from 'react-router-dom';
import { LanguageLoader } from '../../assets/languages';
import {useSelector} from "react-redux";

const SidebarItem = (item) => {
	const settings = useSelector((state) => state.settings);
	const preferences = useSelector((state) => state.preferences);
	const language = LanguageLoader(preferences.language);
	const [isOpen, SetOpen] = useState(false);
	const location = useLocation();
	if(item.children && item.children.length)
	{

		let title = item.title.toUpperCase();
		let label = language.MENU[title] ? language.MENU[title] : item.title;
		let childItems = Object.values(item.children).map((child, childIndex) =>
		{
			/* CHECKING ACCESS */
			const moduleName = child.path.replace('/edit/', '').replace('/list/', '');
			if(settings.definitions.modules[moduleName] || item.component === 'Dynamic')
			{
				const definition = settings.definitions.modules[moduleName];
				if((child.path.indexOf('/edit/') > -1 && !definition.access.create) || (child.path.indexOf('/list/') > -1 && !definition.access.list))
				{
					return null;
				}
				return <li key={childIndex} className={child.path === location.pathname ? 'selected' : ''}><Link to={child.path}><i className={"mx-2 "+child.icon}></i><span>{language.MENU[child.title.toUpperCase()] ? (language.MENU[child.title.toUpperCase()] + ' ' + label) : child.title}</span></Link></li>
			}
			return null;
		});
		return (childItems.filter(item => item).length) ? <div className={isOpen ? "open" : null}>
			<span onClick={() => SetOpen(!isOpen)}>
				<i className={item.icon}></i>
				<span className="mx-2">{label}</span>
				<i className='fa fa-chevron-down text-xs mr-auto'></i>
			</span>
			<ul>
				{childItems.filter(item => item)}
			</ul>
		</div> : null;
	}
	else
	{
		let label = language.MENU[item.title.toUpperCase()] ? language.MENU[item.title.toUpperCase()] : item.title;
		return (
			<div className={item.path === location.pathname ? 'selected' : ''}>
				<Link to={item.path}>
					<i className={item.icon}></i><span className="mx-2">{label}</span>
				</Link>
			</div>
		);
	}
}

export default SidebarItem;